module.exports = __webpack_public_path__ + "static/Contact_Header_BG-a62880d95486526be590188aad23050c.jpg";